<script setup lang="ts">
import { ref } from 'vue';
import PrinterList from '@/views/management/components/setup/PrinterList.vue';
import { Search } from '@xpos/icons-svg';

const $props = defineProps<{
  modelValue?: string;
}>();

const $emit = defineEmits<{
  (event: 'change', value: string): void;
  (event: 'update', value: string): void;
  (event: 'update:modelValue', value: string): void;
}>();

const printerListVisible = ref(false);
const value = ref($props.modelValue);
const handleSelectPrint = (ip: string) => {
  $emit('update:modelValue', ip);
  printerListVisible.value = false;
};

const onChange = () => {
  $emit('change', value.value as string);
  $emit('update:modelValue', value.value as string);
};
</script>

<template>
  <div>
    <el-space :size="5">
      <!-- <span class="text-[#a3a3a3] text-xl">
      {{ $props.modelValue }}
    </span> -->
      <el-input
        v-model="value"
        @change="onChange"
        @input="onChange"
        style="width: 367px"
        placeholder="000.000.000.000"
      ></el-input>
      <el-button type="primary" class="shrink-0 w-[50px]" @click="printerListVisible = true"
        ><el-icon size="20"><Search /></el-icon
      ></el-button>
    </el-space>
    <PrinterList v-model="printerListVisible" @select="handleSelectPrint" @close="printerListVisible = false" />
  </div>
</template>
